import React from "react";

import CountOnPage from "./../../../shared/countOnPage";
import ControlCountOnPage from "./../../../shared/controlCountOnPage";

import styles from "./carsPaginationSettingsPanel.module.scss";

const carsPaginationSettingsPanel = () => {
  return (
    <div className={styles.carsPaginationSettingsPanel}>
      <div className={styles.container_count}>
        Всего: <CountOnPage />
      </div>
      <div className={styles.container_viewCount}>
        <ControlCountOnPage />
      </div>
    </div>
  );
};

export default React.memo(carsPaginationSettingsPanel);
